"use strict";

class CustomerHistoryController {

    constructor(SSHttpService, SSUtilService, SSAppService, SSUserService, SSConfirmationService) {
        const self = this;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.userHistory = null;
        self.currentPage = 0;
        self.pageSize = 5;

        self.init();
    }


    init() {
        const self = this;

        self.SSAppService.historyPage = true;
        self.SSAppService.isPageLoaded = true;

        self.getPropertyViewHistory();
        //self.getUnitViewHistory();
    }

    propertyBoxClick(property) {
        this.SSAppService.viewProperty(property.named_id);
    }

    unitViewClick(unit) {
        this.SSAppService.viewUnit(unit.property_id, unit.named_id);
    }

    getPropertyViewHistory() {
        const self = this;

        loading(true);
        self.SSHttpService.getAPIRequest('sec/get-property-track-views').then(
            function (response) {
                loading(false);

                if (response instanceof Error) {
                    return;
                }

                self.propertyViewHistory = [];
                for (var key in response.data.properties) {
                    self.propertyViewHistory.push(response.data.properties[key]);
                }
            }
        );
    }

    getUnitViewHistory() {
        const self = this;

        loading(true);
        self.SSHttpService.getAPIRequest('sec/get-unit-track-views').then(
            function (response) {
                loading(false);

                if (response instanceof Error) {
                    return;
                }
                self.unitViewHistory = response.data.property_units;
            }
        );
    }

    numberOfPages() {
        const self = this;
        if (self.unitViewHistory.length > 10) {
            return Math.ceil(self.unitViewHistory.length / self.pageSize);
        }
    }

    addIntegerWithZero(number) {
        return (number < 10 ? '0' : '') + number
    }

    customerPropertyDetail(id) {
        const self = this;
        let url = self.SSHttpService.getServerURL('properties/' + id);
        window.location.href = url;
    }

    customerHistoryDetails(propertyId, namedId) {
        const self = this;
        let url = self.SSHttpService.getServerURL('properties/' + propertyId + '/units/' + namedId);
        window.location.href = url;
    }

    removeFromHistory(table_id, column_id) {
        const self = this;

        let message = 'Are you sure you want to remove all ' + table_id + ' from history?';
        if (typeof column_id != 'undefined') {
            message = 'Are you sure you want to remove this from history?';
        }

        let params = {
            table_id: table_id,
            column_id: column_id
        };
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            message,
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                loading(true);
                self.SSHttpService.postAPIRequest('sec/delete-history', params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        console.error(response);
                        return;
                    }

                    let actionOn = 'history-pro-';
                    if (table_id == "units") {
                        actionOn = 'history-unit-';
                        self.getUnitViewHistory();
                    }
                    else {
                        self.getPropertyViewHistory();
                    }


                    if (typeof column_id != 'undefined') {
                        jQuery('.' + actionOn + column_id).remove();
                    } else {
                        jQuery('[class*="' + actionOn + '"]').remove();
                    }
                });
            }
        );
    }

}


CustomerHistoryController.$inject = ['SSHttpService', 'SSUtilService','SSAppService', 'SSUserService', 'SSConfirmationService'];
app.controller('CustomerHistoryController', CustomerHistoryController);

app.filter('startFrom', function() {
    return function (input, start) {
        start = +start; //parse to int
        return input.slice(start);
    }
});